const AccountSignup = function () {
    let $challenge = $('.shopify-challenge__container');
    if ( $challenge.length > 0 ) {
        let $form = $challenge.find('form');
        $form.append('<input type="hidden" name="return_to" value="/account">');
    }
}

export default AccountSignup;